export default "/_next/static/6d37363ce0aa42532a140722af1a84c8.png";